import type { Event, getDefaultIntegrations } from '@sentry/nextjs';

// @sentry/nextjs は Integration の型を出さないため、既定の統合の戻り値から取る
type Integration = ReturnType<typeof getDefaultIntegrations>[number];

/**
 * Sentry SDK が既定で入れる Dedupe は、直前と同じメッセージの警告を捨てる。
 * 同じ失敗が続けて起きるチャットのタイムアウトが、1 件しか残らなくなる。
 * 数えたいメッセージだけを素通しにし、ほかのイベントは Dedupe のまま扱う（連続する同じ例外で枠を使い切らないため）。
 */
export const DEDUPE_INTEGRATION_NAME = 'Dedupe';

/** チャットのタイムアウトを Sentry へ送るときのメッセージ。送る側と、Dedupe の素通しの両方がこの値を使う。 */
export const CHAT_STREAMING_TIMEOUT_MESSAGE = 'chat_streaming_timeout';

const UNDEDUPED_MESSAGES: readonly string[] = [CHAT_STREAMING_TIMEOUT_MESSAGE];

const isUndeduped = (event: Event): boolean =>
  event.message !== undefined && UNDEDUPED_MESSAGES.includes(event.message);

export const dedupeExceptTimeouts = (integrations: Integration[]): Integration[] =>
  integrations.map(integration => {
    const { processEvent } = integration;
    if (integration.name !== DEDUPE_INTEGRATION_NAME || !processEvent) {
      return integration;
    }
    return {
      ...integration,
      processEvent: (event, hint, client) =>
        isUndeduped(event) ? event : processEvent.call(integration, event, hint, client),
    };
  });
